<template>
	<form class="content content-500 column detail-page flexible article padded" @submit="subscribeToProduct">
		<header class="row centering separated">
			<router-link class="rigid" to="/"><i class="fas fa-arrow-left"></i></router-link>
			<h1 class="rigid">Redeem Code</h1>
		</header>

		<div class="column centering">
				<div class="panel" :class="{transparent:couponDetails}">
					<label for="couponCode" class="label">Prepaid Code</label>
					<redeem-code-input :coupon-applied="couponApplied" :processing="processing" v-on:on-submit-code="applyCoupon" :value="couponCodeModel"></redeem-code-input>
					<blockquote v-if="couponDetailsError" class="notice error">
						<button type="button" class="close link" @click="resetCouponState">×</button>
						<span>
							This code didn't work.
							<br>
							If you think it should, <a href="mailto:scope@support.tekcloud.com?subject=Error%20Redeeming%20Code">let us know</a>.
						</span>
					</blockquote>
				</div>

				<div v-if="subscribedSuccess" class="panel column">
					<div class="notice success no-margin"><i class="fas fa-check-circle"></i> Prepaid Code Redeemed</div>
					<h4>What would you like to do next?</h4>
					<div class="column separated">
						<button type="button" class="text-center flexible" @click="resetState">Redeem Another Code</button>
						<a v-if="product === 'scope'" :href="scopeInstallUrl" class="button capitalize text-center flexible">Install TekScope</a>
						<a v-else :href="driveUrl + '&r=subcode'" class="button capitalize text-center flexible">Open TekDrive</a>
						<router-link class="button text-center flexible" to="/">Go to Account Home</router-link>
					</div>
				</div>

				<div v-else-if="couponDetails" class="panel column separated-extra">
					<section class="column rigid separated-extra">
						<h2 class="centered">{{couponDetails.plan}}</h2>

						<div class="rigid badge badge-pill badge-muted badge-large capitalize centered">
							{{couponDetails.durationLabel}} Prepaid
						</div>

						<div v-if="couponDetails.isMaintenance" class="column flexible separated centering">
							<div v-if="selectedSubscription">
								<div v-if="couponDetails.maintenanceEnds" class="rigid">Get latest software updates until {{ couponDetails.maintenanceEnds | date }} for</div>
								<div class="column select-wrapper flexible fill" v-if="product === 'scope'">
									<select class="row flexible trailing-off" :disabled="filteredPerpetualSubs.length === 1" @change="setSelection(selectedSubscription)" v-model="selectedSubscription" name="subscription">
										<option disabled value="">Please select a subscription</option>
										<option v-for="option in filteredPerpetualSubs" v-bind:key="option.id" v-bind:value="option">
											<div>{{ option.plan.displayName }} - Maintenance ending {{option.maintenanceEnds | date}}</div>
										</option>
									</select>
								</div>
							</div>
							<div v-else class="notice error">
								A Perpetual {{couponDetails.planTier}} Subscription is required to redeem this coupon code.
							</div>
						</div>

						<ul v-if="couponDetails.addOns && couponDetails.addOns.length" class="rigid list-group bullets centered">
							<li v-bind:key="index" v-for="(addOn, index) in couponDetails.addOns" class="list-item bullet row separated">
								<div class="bullet-margin rigid">
									<i class="fas fa-check info"></i>
								</div>
								<label class="bullet-content row flexible separated">
									{{addOn}}
								</label>
							</li>
						</ul>
					</section>
					<footer class="rigid row" v-if="couponDetails">
						<button type="submit" :disabled="subscriptionRequired" class="primary flexible">
							<span v-if="submitting">
								<i class="fas fa-spinner fa-spin"></i>
							</span>
							<span v-else>
								<span>Redeem</span>
							</span>
						</button>
					</footer>
					<div v-if="createSubscriptionError" class="row rigid">
						<div v-if="createSubscriptionError.type === 'NEEDS_REVIEW'" class="notice warning">
								<p>
									In compliance with U.S. Government regulation, Tektronix is required to review all software download activity. Our team has been notified and will contact you once your account has been cleared.
									This process may take up to two U.S. business days. We apologize for any inconvenience.
								</p>
								<p>
									If you have any questions, please <a href="mailto:export-control@support.tekcloud.com?subject=Account%20Under%20Review">contact us</a>.
								</p>
							</div>
						<div v-else class="notice error">
							There was an error redeeming your code. Please <a href="mailto:scope@support.tekcloud.com?subject=Error%20Redeeming%20Code">contact support</a>.
						</div>
					</div>
				</div>
				<footer class="redeem" v-if="couponDetails && !subscribedSuccess">
					<button type="button" @click="resetState" class="link">Cancel</button>
				</footer>
		</div>
	</form>
</template>

<script>
import SubmitButton from '../components/SubmitButton';
import duration from '../filters/duration';
import date from '../filters/date';
import { mapGetters, mapState } from 'vuex';
import RedeemCodeInput from '@/components/RedeemCodeInput';


export default {
	name: 'RedeemCode',
	components:{
		RedeemCodeInput
	},
	filters: {
		duration,
		date
	},
	data(){
		return {
			couponCodeModel: '',
			submitting: false,
			processing: false,
			couponDetailsError: null,
			createSubscriptionError: null,
			couponDetails: null,
			subscribedSuccess: false,
			subId: ''
		};
	},
	computed:{
		...mapGetters('auth', {
			scopeUrl: 'installTekScopeUrl',
			driveUrl: 'driveAppUrl',
			scopeAddressUrl: 'scopeAddressUrl',
		}),
		...mapGetters([
			'user',
			'account',
			'accountStatus'
		]),
		...mapGetters('scope',[
			'perpetualScopeSubs',
		]),
		returnPath(){
			return this.$route.query.returnPath || '/subscriptions';
		},
		product(){
			return this.couponDetails && this.couponDetails.product || 'scope';
		},
		subscriptionRequired(){
			return this.couponDetails?.isMaintenance && this.selectedSubscription === null;
		},
		couponApplied() {
			return this.couponDetails != null;
		},
		scopeInstallUrl() {
			return this.scopeUrl + '&r=' + (this.subscriptionRequired ? 'maintenance' : 'add') + '&subid=' + this.subId;
		},
		filteredPerpetualSubs() {
			return this.perpetualScopeSubs.filter(sub => sub?.plan?.tierName === this.couponDetails?.tierName);
		},
		selectedSubscription: {
			get() {
				return this.$store.state.coupon.selectedSubscription;
			},
			set(value) {
				this.$store.dispatch('coupon/SELECT_SUBSCRIPTION', value);
			},
		},
	},
	created(){
		this.$store.dispatch('subscription/GET_TEK_SUBSCRIPTIONS_REQUEST');
	},
	methods:{
		applyCoupon(couponCode) {
			const vm = this;
			vm.processing = true;
			vm.couponCodeModel = couponCode;

			this.$store.dispatch('coupon/GET_COUPON_DETAILS', couponCode)
				.then(response => {
					vm.couponDetails = response;
					vm.processing = false;
				})
				.catch(error => {
					vm.couponDetailsError = error;
					vm.processing = false;
				});
		},
		subscribeToProduct(e) {
			e.preventDefault();
			let vm = this;
			vm.submitting = true;

			const subRequest = {
				prepaidCouponId: vm.couponCodeModel,
				...(vm?.selectedSubscription?.id && {subId: vm.selectedSubscription.id}),
			};

			vm.$store.dispatch(vm.product + '/ADD_SUBSCRIPTION_REQUEST', subRequest)
				.then((response) => {
					vm.subscribedSuccess = true;
					vm.subId = response?.id;
				})
				.catch(error => {
					vm.submitting = false;
					// currently only scope requires an address so send them to scope onboarding flow
					if (error.type === 'MISSING_ADDRESS') {
						window.location.href = vm.scopeAddressUrl + '&subcode=' + vm.couponCodeModel;
						return;
					}
					vm.createSubscriptionError = error;
				})
				.finally(() => {
					vm.submitting = false;
				});

		},
		resetCouponState() {
			this.couponDetailsError = null;
		},
		resetState() {
			this.couponDetails = null;
			this.couponCodeModel = '';
			this.couponDetailsError = null;
			this.subscriptionError = null;
			this.createSubscriptionError = null;
			this.subscribedSuccess = false;
			this.$store.dispatch('coupon/SELECT_SUBSCRIPTION', null);
		},
		setSelection(sub) {
			this.selectedSubscription = sub;
			this.$store.dispatch('coupon/UPDATE_MAINTENANCE_EXPIRY', {coupon: this.couponDetails, currentSub: sub})
				.then(response => {
					this.couponDetails = response;
				});
		}
	}

};
</script>

<style scoped>
.page {
	background: #f6f6f6;
	margin-bottom: 0;
}
section > label {
	max-width: 300px;
}
select[disabled] {
	cursor: not-allowed;
	/* Remove dropdown arrow when disabled */
	-webkit-appearance: none;
	-moz-appearance: none;
}
.select-wrapper {
	margin-top: 1em !important;
	max-width: 400px;
}
@media only screen and (max-width: 900px) {
	.page {
	    max-width: unset;
	    margin: 0 auto;
	}
}
@media only screen and (max-width: 450px) {
	.redeem.row {
		flex-direction: column-reverse;
    	text-align: center;
	}
	.redeem.row.separated > * + .rigid {
		margin: 1em auto;
	}
	.redeem.row button + button {
		margin-bottom: 1em;
		margin-left: 0;
	}
}

.column.separated-extra > * + .gap,
.column.separated-extra > * + .rigid,
.column.separated-extra > * + .flexible,
.column.separated-extra > * + .fill {
    margin-top: 2em;
}


.bullet-content {
	text-align: left;
	color: #777;
}

.list-item {
	font-size: 18px
}
.list-group .list-item:last-child {
	padding-bottom: 0;
}

.content-narrow .empty h2 {
	margin-bottom: 0;
}

.content-narrow h1 i {
	transform: rotate(-25deg);
	margin-right: 1rem;
}

.content.content-narrow {
	max-width: 400px;
	width: 100%;
	box-sizing: border-box;
}

.content-narrow .panel h2 {
    margin: auto;
    color: #293F52;
	line-height: 1.4rem;
}

h2.centered {
	text-align: center;
}

.content-narrow .panel.empty p {
	margin-top: 1em;
	margin-bottom: 0;
	color: #888;
}

.redeem button {
	width: 100%;
}

.panel + .panel {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	border-top: none !important;
}

.panel:first-child {
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}

.panel:first-child:last-child {
	border-radius: .5rem;
}

.panel + footer {
	margin-top: 1em;
}



.panel {
	background: white;
	border-radius: 6px;
	padding: 2rem;
	border: 2px solid #dfdfdf;
	width: 100%;
	margin: auto;
	box-sizing: border-box;
}
.dark .panel {
	background: #1a1a1a;
	border: 2px solid #333;
}

.panel footer {
	margin-top: 2em;
}


.apply-code {
	width: 100px;
}

.transparent {
	background: transparent;
}

.notice {
	text-align: left;
}

@media only screen and (max-width : 500px) {
	.panel > .row {
		flex-direction: column;
	}
	.separated.row > button.apply-code {
		margin-left: auto;
	    margin-right: 0;
	    margin-top: .5rem;
	}
}

</style>



// WEBPACK FOOTER //
// ./src/views/RedeemCode.vue